import { render, staticRenderFns } from "./CompanyImprintsComponent.vue?vue&type=template&id=8a58bf8c&scoped=true&"
import script from "./CompanyImprintsComponent.vue?vue&type=script&lang=js&"
export * from "./CompanyImprintsComponent.vue?vue&type=script&lang=js&"
import style0 from "./CompanyImprintsComponent.vue?vue&type=style&index=0&id=8a58bf8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a58bf8c",
  null
  
)

export default component.exports